export interface IClonePropertyRequest {
	PropertyId: number;
	IncludeHistory: boolean;
	IncludePaperPublicity: boolean;
	IncludePublicityConfiguration: boolean;
	IncludeDocuments: boolean;
	IncludeChecklist: boolean;
	IncludeCheckup: boolean;
	IncludeCost: boolean;
	IsDeleteOriginalHistory: boolean;
	ProjectId?: number;
}

export class ClonePropertyRequest implements IClonePropertyRequest {
	public PropertyId: number;
	public IncludeHistory: boolean;
	public IncludePaperPublicity: boolean;
	public IncludePublicityConfiguration: boolean;
	public IncludeDocuments: boolean;
	public IncludeChecklist: boolean;
	public IncludeCheckup: boolean;
	public IncludeCost: boolean;
	public IsDeleteOriginalHistory: boolean;
	public ProjectId?: number;

	constructor(payload?: IClonePropertyRequest) {
		this.PropertyId = payload ? payload.PropertyId : 0;
		this.IncludeHistory = payload ? payload.IncludeHistory : false;
		this.IncludePaperPublicity = payload ? payload.IncludePaperPublicity : false;
		this.IncludePublicityConfiguration = payload ? payload.IncludePaperPublicity : false;
		this.IncludeDocuments = payload ? payload.IncludePaperPublicity : false;
		this.IncludeChecklist = payload ? payload.IncludePaperPublicity : false;
		this.IncludeCheckup = payload ? payload.IncludePaperPublicity : false;
		this.IncludeCost = payload ? payload.IncludePaperPublicity : false;
		this.IsDeleteOriginalHistory = payload ? payload.IsDeleteOriginalHistory : false;
		this.ProjectId = payload ? payload.ProjectId: null
	}
}

export class CloneProjectRequest {
	public IncludeHistory: boolean;
	public IsDeleteOriginalHistory: boolean;
	public IncludeDocuments: boolean;
	public IncludeChecklist: boolean;

	constructor(payload) {
		this.IncludeChecklist = payload.IncludeChecklist;
		this.IsDeleteOriginalHistory = payload.IsDeleteOriginalHistory;
		this.IncludeDocuments = payload.IncludeDocuments;
		this.IncludeHistory = payload.IncludeHistory;
	}
}

export interface IClonePropertyResponse {
	PropertyId: number;
}
export interface ICloneProjectResponse {
	ProjectId: number;
	Success: boolean;
}